import React from 'react';

import { ReactComponent as AssassinSymbol } from '../assets/assassin.svg';

type Props = {
  title: string;
  value: number;
  setValue: (num: number) => void;
  showAssassinSymbol?: boolean;
  numAssassin?: number;
  className: string;
};

/**
 * One row of input for number of dice of a certain type
 *  with optional display for number of Assassin symbols rolled
 * @param props
 */
const DiceInputRow: React.FC<Props> = (props) => {
  const {
    title,
    value,
    setValue,
    showAssassinSymbol,
    numAssassin,
    className,
  } = props;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number(event.target.value));
  };

  return (
    <div
      className={`row ${className}`}
    >
      <label className="row__title" htmlFor={title}>{title}</label>
      <div className="row__numbers">
        <input
          className="row__input-num"
          type="number"
          value={value || ''}
          onChange={onChange}
          id={title}
        />
        <div className="row__icon__container">
          {showAssassinSymbol &&
            <span className="row__icon__holder">
              <span>{numAssassin}</span>
              <AssassinSymbol />
            </span>}
        </div>
      </div>
    </div>
  );
};

DiceInputRow.defaultProps = {
  showAssassinSymbol: false,
  numAssassin: 0,
};

export default DiceInputRow;
